var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer",class:_vm.list.length > 2 ? '' : 'bottom'},[_c('div',{staticClass:"foot-text",attrs:{"bis_skin_checked":"1"}},[_c('p',[_vm._v("细节精雕 彰显与众不同 "+_vm._s(_vm.name)+"版权所有。")])])])}
var staticRenderFns = []

export { render, staticRenderFns }